/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import Header from '../../components/includes/Header';
import HeaderTitle from '../../components/includes/HeaderTitle';

import "../../css/style.css";

//아이디 찾기
const FoundPWDOK = () => {

  return (
    <div className="vh-container">
      <Header varGoToMain={false} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'비밀번호 변경'}/>
        <div className="vh-content-body" style={{padding:"60px"}}>
          <div className="form-guide">
            <p>비밀번호가 변경되었습니다. <br/> 변경된 비밀번호로 로그인해주세요.</p>
					</div>
					<div className="form-contoller flex-horizontal mt-auto mb50" style={{marginTop:"60px"}}>
						<Link to="/Login" className="form-contoller-btn">로그인하기</Link>
					</div>
        </div>
      </div>
    </div>
  );
}
export default FoundPWDOK;